import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const ChevronLeftIcon = forwardRef<SVGSVGElement, IconProps>(function ChevronLeftIcon(
  { color, height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6102 5.89881C10.7273 6.01943 10.7273 6.21499 10.6102 6.3356L8.02525 8.9999L10.6102 11.6642C10.7273 11.7848 10.7273 11.9804 10.6102 12.101C10.4932 12.2216 10.3035 12.2216 10.1865 12.101L7.38956 9.2183C7.27253 9.09768 7.27253 8.90212 7.38956 8.7815L10.1865 5.89881C10.3035 5.77819 10.4932 5.77819 10.6102 5.89881Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8237 5.6788C11.0586 5.92092 11.0586 6.31349 10.8237 6.55562L8.45218 8.9999L10.8237 11.4442C11.0586 11.6863 11.0586 12.0789 10.8237 12.321C10.5888 12.5631 10.2079 12.5631 9.97299 12.321L7.17609 9.43831C6.94117 9.19619 6.94117 8.80362 7.17609 8.56149L9.97299 5.6788C10.2079 5.43667 10.5888 5.43667 10.8237 5.6788ZM7.77824 8.82093L7.60459 8.9999L7.77824 9.17888C7.70507 9.07187 7.70507 8.92794 7.77824 8.82093Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.751 12.2542C10.9495 12.0496 10.9495 11.7156 10.751 11.511L8.37946 9.06669C8.34309 9.0292 8.34309 8.97061 8.37946 8.93311L10.751 6.48883C10.9495 6.28419 10.9495 5.95022 10.751 5.74559C10.5555 5.54413 10.2412 5.54413 10.0457 5.74559L7.24881 8.62828C7.05027 8.83292 7.05027 9.16689 7.24881 9.37152L10.0457 12.2542C10.2412 12.4557 10.5555 12.4557 10.751 12.2542ZM10.8964 11.3774C11.1677 11.657 11.1677 12.1082 10.8964 12.3878C10.622 12.6706 10.1747 12.6706 9.90027 12.3878L7.10338 9.5051C6.83208 9.22548 6.83208 8.77432 7.10338 8.4947L9.90027 5.61201C10.1747 5.3292 10.622 5.3292 10.8964 5.61201C11.1677 5.89163 11.1677 6.34279 10.8964 6.62241L8.5897 8.9999L10.8964 11.3774ZM10.5375 6.26881C10.6182 6.18569 10.6182 6.04873 10.5375 5.9656C10.46 5.88566 10.3367 5.88566 10.2592 5.9656L7.46228 8.8483C7.38163 8.93142 7.38163 9.06838 7.46228 9.15151L10.2592 12.0342C10.3367 12.1141 10.46 12.1141 10.5375 12.0342C10.6182 11.9511 10.6182 11.8141 10.5375 11.731L7.95253 9.06669C7.91616 9.0292 7.91616 8.97061 7.95253 8.93311L10.5375 6.26881ZM10.683 5.83202C10.8364 5.99013 10.8364 6.24428 10.683 6.4024L8.16277 8.9999L10.683 11.5974C10.8364 11.7555 10.8364 12.0097 10.683 12.1678C10.5265 12.3291 10.2702 12.3291 10.1137 12.1678L7.31684 9.28509C7.16344 9.12698 7.16344 8.87283 7.31684 8.71471L10.1137 5.83202C10.2702 5.67073 10.5265 5.67073 10.683 5.83202ZM7.84049 8.74477C7.88114 8.77623 7.89027 8.83274 7.8615 8.87482C7.81065 8.94919 7.81065 9.05062 7.8615 9.12498C7.89027 9.16706 7.88114 9.22357 7.84049 9.25503C7.79983 9.28649 7.74118 9.28242 7.70553 9.24567L7.53188 9.06669C7.4955 9.0292 7.4955 8.9706 7.53188 8.93311L7.70553 8.75414C7.74119 8.71738 7.79983 8.71332 7.84049 8.74477Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
